import React from "react";
import styled from "styled-components";
// Assets
import latte1 from "../assets/img/latte1.png";
import latte2 from "../assets/img/latte2.png";
import latte3 from "../assets/img/latte3.png";
import PrinterIcon from "../assets/svg/Services/PrinterIcon";

export default function ServiceBox({icon, title, subtitle}) {
  let getIcon;

  switch (icon) {
    case "latte1":
      getIcon = latte1;
      break;
    case "latte2":
      getIcon = latte2;
      break;
    case "latte3":
      getIcon = latte3;
      break;
    case "printer":
      getIcon = <PrinterIcon />;
      break;
    default:
      getIcon = latte1;
      break;
  }


  return (
    <Wrapper className="flex flexColumn">
      <IconStyle className="latte-icon" src={getIcon}/>
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.img`
  height: 180px;
  width: 180px;
  margin: auto;
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 10px 0;
  @media (max-width: 860px) {
    padding: 10px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;